import React, { useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import { Link } from 'react-router-dom';

const TestDeployment = () => {
  useDocTitle('Try a Test Deployment');
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <NavBar />
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-lg shadow p-8">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">See our deployments in action !</h1>
          <p className="text-gray-700 mb-4">Clone our demo repository, make a change, and push it back up. Our platform will automatically rebuild and deploy for you.</p>
          <ol className="list-decimal list-inside text-gray-700 mb-4 space-y-1">
            <li>Fork or clone <a href="https://github.com/Artisan-Hosting/demo" target="_blank" rel="artisanhosting.net" className="text-blue-900 underline">Demo Repository</a>.</li>
            <li>Commit a small change.</li>
            <li>Open a pr to the release branch ?.</li>
            <li>Push to GitHub and watch the deployment.</li>
          </ol>
          <p className="text-gray-700 mb-2">See it live at <a href="https://demo.artisanhosting.net" className="text-blue-900 underline" target="_blank" rel="artisanhosting.net">demo.artisanhosting.net</a>.</p>
          <p className="text-gray-700 mb-6">Status links coming soon.</p>
          <div className="my-8 flex justify-center">
            <Link
              to="/contact"
              className="bg-blue-900 text-white hover:bg-blue-800 px-6 py-3 rounded-lg shadow"
            >
              If we impressed you let's get in touch
            </Link>
          </div>
          <Link to="/" className="text-blue-900 underline">Back to Home</Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TestDeployment;
